import { formHelp } from './formHelpers'
import { FoundationsRequest, getBaseUrl } from '../../Utils'
import { ReactBarcode } from 'react-jsbarcode'
import { CopyIcon } from '../../GenericComponents/copyIcon'
import { AccordionItem } from '../../GenericComponents/accordion'
import { ObjectContext } from '../../Components/OCV/OCVTypes'

declare let window: any

export const FormBanner = (props: { lauoutObj: { color: string; component: any[] } }) => {
    const lauoutObj = props.lauoutObj
    return (
        <span
            className="darken"
            style={{
                display: 'inline-block',
                fontWeight: 'bold',
                fontSize: '12px',
                backgroundColor: '' + lauoutObj.color,
            }}
        >
            {lauoutObj.component.length > 0
                ? lauoutObj.component[0][Object.keys(lauoutObj.component[0])[0]]
                : ''}
        </span>
    )
}

export const FormTable = (props: {
    render: string
    component: any[]
    title: string
    collapsed: any
    j_index: string | number
    index: number
    setDialogObject: (arg0: ObjectContext) => void
    setDialogVisible: (arg0: boolean) => void
}) => {
    const {
        render,
        component,
        title,
        collapsed,
        j_index,
        index,
        setDialogObject,
        setDialogVisible,
    } = props
    const id = 'form_table_' + index
    const formattedTableHTML = formHelp.getOCVFormattedView(
        component,
        id,
        setDialogObject,
        setDialogVisible
    )

    return (
        <div
            className={
                'layout_table ' +
                (collapsed ? 'collapsed' : '') +
                (render === 'left' ? ' noprint' : '') +
                ' mb-3'
            }
            key={id}
        >
            <AccordionItem
                accordionHeader={title}
                id={'form_table_' + index}
                headerClasses={'w-100 form-table-header'}
                contentClasses={'w-100 p-0 show-print'}
                open={!collapsed}
            >
                {formattedTableHTML}
            </AccordionItem>
        </div>
    )
}

// TODO handle highlighting!!!
// App.Foundations.OCV_Hilitor(id, lauoutObj.highlightPhrases)

export const FixedTable = (props: {
    render: string
    component: any[]
    title: string
    j_index: string | number
    index: number
    setDialogObject: (arg0: ObjectContext) => void
    setDialogVisible: (arg0: boolean) => void
}) => {
    const { render, component, title, j_index, index, setDialogObject, setDialogVisible } = props
    const id = 'form_table_' + index
    const formattedTableHTML = formHelp.getOCVFormattedView(
        component,
        id,
        setDialogObject,
        setDialogVisible
    )
    if (render === 'left') {
        return (
            <div className="noprint" key={id}>
                {/* <h4>{title}</h4> */}
                <h4 className="form-table-header">{title}</h4>
                {formattedTableHTML}
            </div>
        )
    } else {
        return (
            <div className="fixed_layout_table my-3" key={id}>
                {/* <h4>{title}</h4> */}
                <h4 className="form-table-header">{title}</h4>
                {formattedTableHTML}
            </div>
        )
    }
}

export const FormList = (props: { component: any[]; title: string; j: number; index: number }) => {
    const { component, title, j, index } = props
    const list = component
    const listid = `list_view_${j}`
    const key = 'form_center_list_' + index

    return (
        <div className="list_view" id={listid} key={key}>
            <h4>{title}</h4>
            {list.map((item, index) => {
                return (
                    <p
                        key={index}
                        dangerouslySetInnerHTML={{
                            __html:
                                item !== undefined &&
                                Object.keys(item[Object.keys(item)[0]]).length === 0
                                    ? ''
                                    : item[Object.keys(item)[0]],
                        }}
                    ></p>
                )
            })}
        </div>
    )
    // TODO !! handle highlighting
    // if (typeof lauoutObj.highlightPhrases === 'string') { //FP-9070 String check as code should handle in both way for one word and multiple words.
    //     App.Foundations.OCV_Hilitor(listid, lauoutObj.highlightPhrases)
    // } else {
    //     if (lauoutObj.highlightPhrases && lauoutObj.highlightPhrases.length > 0) { //FP-9070 adding check for null,empty and undefined.
    //         lauoutObj.highlightPhrases.forEach(function (phrase) {   //FP-9070 highlighting multiple words and getting phrases in array.
    //             App.Foundations.OCV_Hilitor(listid, phrase, true);
    //         });
    //     }
    // }
}

// TODO!! where is this pointing? how do we make sure APIs are handled correctly?
export const API = (lauoutObj: { [s: string]: any }) => {
    const APIOptions = lauoutObj
    APIOptions.ajaxOpts.url = APIOptions.ajaxOpts.url.replace('$baseURL/', getBaseUrl())
    FoundationsRequest('GET', {
        url: APIOptions.ajaxOpts.url,
        data: {},
        includeTokenHeader: true,
        success: function (externalResponse: any) {
            if (APIOptions.ajaxOpts.successHandler) {
                let successHandler = window
                const pathToSuccessHandler = APIOptions.ajaxOpts.successHandler.split('.')
                for (let i = 0; i < pathToSuccessHandler.length; i++) {
                    successHandler = successHandler[pathToSuccessHandler[i]]
                    if (!successHandler) {
                        break
                    }
                }
                if (successHandler) successHandler(externalResponse)
                else {
                    console.error('Unable to obtain successhandler to OCV Section.')
                }
            } else {
                // TODO !! handle showing error resposne from API in center tables
                // $("#center_tables").html(JSON.stringify(externalResponse));
                return JSON.stringify(externalResponse)
            }
        },
        error: function (
            request: { responseJSON: { hints: string; statusMessage: string } | null } | null,
            err: any
        ) {
            // TODO !! handle API error response here
            // $("#generic_object_viewer_loading").hide();
            // if (request != null && request.responseJSON != null && request.responseJSON.hints != "") {
            //     $("#generic_object_viewer_content").html("<div class='padding-top-medium'>" + request.responseJSON.statusMessage
            //         + request.responseJSON.hints + "</div>");
            // }
            // else {
            //     $("#generic_object_viewer_content").html("<div class='padding-top-medium'>Sorry, requested object could not be retrieved. Error notification has been sent to IT for assistance.</div>");
            // }
            // window.healthLevelGlobal.handleAjaxPageError(request, err)
        },
    })
}

export const FormButtons = (props: {
    lauoutObj: {
        component: any[]
    }
    signReport: (buttonData: { [s: string]: any }) => void
}) => {
    const { lauoutObj, signReport } = props
    const buttons = lauoutObj.component
    function groupBy(objectArray: any[], property: string) {
        return objectArray.reduce(function (acc, obj) {
            const key = obj[property]
            if (!acc[key]) {
                acc[key] = []
            }
            // Add object to list for given key's value
            acc[key].push(obj)
            return acc
        }, {})
    }
    const buttonGroups: { [s: string]: any[] } = groupBy(buttons, 'WorkflowGroup')
    let groupCount = 0

    return (
        <>
            {Object.keys(buttonGroups)?.map(function (key: string, index: number) {
                groupCount++
                const group = buttonGroups[key]
                return (
                    <div
                        key={index}
                        className="d-flex flex-row justify-content-start px-1 flex-wrap"
                        id={'btnGroup_' + groupCount}
                    >
                        {group?.map(function (value, groupIndex) {
                            const dataStatusVal = value['FormStatus']
                            const dataStatus = value['Id']
                            const dataProcName = value['StoredProcedure']
                            const buttonEnabled =
                                value.IsAllowed === undefined || value.IsAllowed === 1
                            return (
                                <div key={groupIndex} className="statusButtonContainer">
                                    <a
                                        className={'statusButton'}
                                        title={value['FormStatusDescription']}
                                        id={'formStatus_' + value['Id']}
                                        onClick={() => {
                                            if (buttonEnabled)
                                                signReport({
                                                    dataStatusVal: dataStatusVal,
                                                    dataStatus: '' + dataStatus,
                                                    dataProcName: dataProcName,
                                                })
                                        }}
                                    >
                                        <span
                                            className={
                                                'label app-button ' +
                                                (buttonEnabled ? '' : ' app-button-disabled')
                                            }
                                        >
                                            {value['FormStatus'] || 'Undefined'}
                                        </span>
                                    </a>
                                </div>
                            )
                        })}
                    </div>
                )
            })}
            {groupCount < Object.keys(buttonGroups).length - 1 ? <hr /> : <></>}
        </>
    )
}

// TODO: we should not be sending the header information this way from the backend, we need to handle this better
export const FormHeader = (props: {
    lauoutObj: { component: any[] }
    setDialogObject: (arg0: ObjectContext) => void
    setDialogVisible: (arg0: boolean) => void
}) => {
    const { lauoutObj, setDialogObject, setDialogVisible } = props
    let header = lauoutObj.component
    // don't recompute this on every render
    let seperatorIndicies = Object.keys(header[0]).reduce(function (
        a: number[],
        key: string,
        i: number
    ) {
        if (header[0][key] === 'row' || header[0][key] === 'separator') {
            a.push(i)
        }
        return a
    }, [])
    seperatorIndicies.push(header[0].length)
    let previousIndex = -1
    // This code should be far simpler! currently we get an array of fields to render for the header
    // there are some fields marked "row" amd "separator" which are used to mark line breaks and if a seperator line is needed
    // This means we have to parse the header object, iterate over it to find where the line breaks are,
    // Then loop through it again and render the fields between those breaks wrapped in div tags
    return (
        <>
            {header[0] !== undefined ? (
                <>
                    <div className="d-flex flex-row row pl-2">
                        {seperatorIndicies.map((index, i) => {
                            const oldIndex = previousIndex
                            previousIndex = index

                            return (
                                <>
                                    <div
                                        key={i}
                                        className="d-flex flex-row justify-content-start px-1 flex-wrap m-0"
                                    >
                                        {Object.keys(header[0])
                                            .slice(oldIndex + 1, index)
                                            .map((key: string, j: number) => {
                                                if (
                                                    header[0][key] == '' ||
                                                    header[0][key] == null ||
                                                    header[0][key] == undefined ||
                                                    (typeof header[0][key] === 'object' &&
                                                        Object.keys(header[0][key]).length === 0)
                                                ) {
                                                    header[0][key] = 'N/A'
                                                }
                                                return (
                                                    <div key={j} className="phiElement mt-1">
                                                        <span style={{ fontWeight: 'bold' }}>
                                                            {key} :{' '}
                                                        </span>
                                                        <span>
                                                            <span
                                                                dangerouslySetInnerHTML={{
                                                                    // This is very hacky, need to send data from backend another way
                                                                    __html:
                                                                        typeof header[0][key] ===
                                                                            'string' &&
                                                                        !header[0][key].includes(
                                                                            '<a'
                                                                        )
                                                                            ? header[0][
                                                                                  key
                                                                              ].replace(
                                                                                  'style=',
                                                                                  "class='darken' style="
                                                                              ).replace(
                                                                                'onclick',
                                                                                'oldOnClick'
                                                                            )
                                                                            : header[0][key],
                                                                }}
                                                                // Steven: This is not a good way of handling OCV links but this needs
                                                                // further discussion. Needs more discussion with Vedant and/or Adway
                                                                // for how to send OCV configurations for this scenario
                                                                onClick={
                                                                    typeof header[0][key] ===
                                                                        'string' &&
                                                                    header[0][key].includes(
                                                                        'openObjectViewDialog'
                                                                    )
                                                                        ? () => {
                                                                              const index1 =
                                                                                  header[0][
                                                                                      key
                                                                                  ].indexOf('{')
                                                                              const index2 =
                                                                                  header[0][
                                                                                      key
                                                                                  ].indexOf('}')
                                                                              const configString =
                                                                                  index1 > 0 &&
                                                                                  index2 > 0
                                                                                      ? header[0][
                                                                                            key
                                                                                        ]
                                                                                            .substring(
                                                                                                index1,
                                                                                                index2 +
                                                                                                    1
                                                                                            )
                                                                                            ?.replaceAll(
                                                                                                '&quot;',
                                                                                                "'"
                                                                                            )
                                                                                            .replaceAll(
                                                                                                "'",
                                                                                                '"'
                                                                                            )
                                                                                      : '{}'
                                                                              const configObject =
                                                                                  JSON.parse(
                                                                                      configString
                                                                                  )
                                                                              configObject.mdsColumnID =
                                                                                  parseInt(
                                                                                      configObject.mdsColumnID ??
                                                                                          -1
                                                                                  )
                                                                              setDialogObject(
                                                                                  configObject
                                                                              )
                                                                              setDialogVisible(true)
                                                                          }
                                                                        : () => {}
                                                                }
                                                            ></span>
                                                            {formHelp.stripHtml(header[0][key]) && (
                                                                <CopyIcon
                                                                    copyText={formHelp.stripHtml(
                                                                        header[0][key]
                                                                    )}
                                                                    id={
                                                                        'phiElement_' +
                                                                        header[0][key]
                                                                    }
                                                                />
                                                            )}
                                                        </span>
                                                    </div>
                                                )
                                            })}
                                    </div>
                                    {Object.values(header[0]).length > index &&
                                    Object.values(header[0])[index] === 'separator' ? (
                                        <hr
                                            className="my-2 mr-3"
                                            style={{ width: '100%', border: '1px solid #ddd' }}
                                        />
                                    ) : (
                                        <></>
                                    )}
                                </>
                            )
                        })}
                    </div>
                    <hr />
                </>
            ) : (
                <></>
            )}
        </>
    )
}

export const BarCode = (props: { lauoutObj: { component: any[] } }) => {
    const lauoutObj = props.lauoutObj
    // TODO !! handle night mode here
    if (lauoutObj.component[0] !== undefined && Object.keys(lauoutObj.component[0]).length > 0) {
        return (
            <ReactBarcode
                value={lauoutObj.component[0][Object.keys(lauoutObj.component[0])[0]]}
                options={{
                    width: 2,
                    height: 30,
                    displayValue: false,
                }}
            />
        )
    } else {
        return <></>
    }
}
